import React from 'react';
import {Box} from '@mui/material';

export const MapWrapper = ({children}) => {
  return (
    <div style={{width: '100%'}}>
      <Box
        sx={{
          margin: '16px 32px',
          padding: '16px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderColor: 'black',
          borderWidth: '1px',
          borderRadius: '4px 4px 4px 4px'
        }}>
        <Box
          sx={{
            position: 'relative',
            overflow: 'hidden',
            backgroundColor: 'deeppink'
          }}>
          {children}
        </Box>
      </Box>
    </div>
  );
};
export default MapWrapper;
